import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(
    !!localStorage.getItem("kataria_auth")
  );

  const login = () => {
    localStorage.setItem("kataria_auth", "true");
    setIsAuth(true);
  };

  const logout = () => {
    localStorage.removeItem("kataria_auth");
    setIsAuth(false);
  };

  return (
    <AuthContext.Provider value={{ isAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
